module.exports = __webpack_public_path__ + "img/brandme-shop.d22f8e6c.png";